<div *ngIf="initialized">
  <div class="card  mb-0">
    <div>
      <header class="card-header bg-light py-3 px-5">
        <div class="d-flex justify-content-between align-items-center">
          <h3 class="mb-0">{{team?.id ? 'Edit' : 'Add'}} Team</h3>

          <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('cancel')">
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </header>
      <div *ngIf="!disableEditing" class="card-body">
        <form id="form" (ngSubmit)="onSave()" [formGroup]="formGroup" novalidate>
          <div class="row">
            <div class="col-md-6 mb-2">
              <label class="form-control-label" for="name">
                Team Name
              </label>
              <input class="form-control" formControlName="name" maxlength="50" type="text" />
              <div class="invalid-message" *ngIf="formGroup?.controls['name'].errors && formGroup?.controls['name'].errors.required">
                <div>Name is required</div>
              </div>
              <div class='invalid-message' *ngIf="formGroup?.controls['name'].errors && formGroup?.controls['name'].errors.nameTaken">
                Team with this name already exists
              </div>
            </div>
            <div class="col-md-6">
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label class="form-control-label" for="coachIds">
                  Team Coaches
                </label>
                <coaches-multiselect class="form-control" [placeholder]="'Select coaches for team'" formControlName="coachIds"></coaches-multiselect>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label class="form-control-label" for="athleteIds">
                  Team Athletes
                </label>
                <runners-bulk-select class="form-control" [unselectedText]="'Available Athletes'" [selectedText]="'Athletes on Team'" formControlName="athleteIds"></runners-bulk-select>
              </div>
            </div>
          </div>
      </form>
      </div>
      <div class="card-footer">
        <div class="row">
          <div class="col">
            <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss('cancel')">Cancel</button>
          </div>
          <div class="col text-right">
            <button type="submit" form="form" [promiseBtn]="submitComplete" class="btn btn-primary">{{team?.id ? 'Save' : 'Add'}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
